/*
 * Which /tutorial step explains the page you are on — for the top bar's "?"
 * button, which opens the tutorial at that step.
 *
 * Step ids are `<section id>-<n>` from src/views/tutorial/sections.js
 * (`order-2` = the Order votes section's second step). Most specific prefix
 * first; anything unlisted opens the tutorial at the top.
 */
const ROUTES = [
  ["/websites/", "plans-1"], // /websites/:id/subscription — a voting plan
  ["/websites", "order-1"],
  ["/checkout", "order-3"],
  ["/campaigns/chart", "results-1"],
  ["/campaigns", "manage-1"],
  ["/logs/", "results-2"],
  ["/products", "tokens-1"],
  ["/replenish", "tokens-2"],
  ["/subscription-plans", "tokens-1"],
  ["/invoices", "account-2"],
  ["/dashboard", "start-1"],
  ["/discord-tokens", "settings-3"],
  ["/advanced/profiles/proxy", "settings-2"],
  ["/advanced/profiles", "settings-1"],
  ["/account", "account-1"],
  ["/notifications", "notifications-1"],
  ["/support", "help-1"],
];

/** The step for `path`, or null to open the tutorial at the top. */
export function tutorialStepFor(path = "") {
  if (path === "/") return "manage-1"; // the root route renders Campaigns too
  // A prefix ending in "/" claims only what is under it; any other matches
  // itself and its sub-paths.
  const hit = ROUTES.find(([prefix]) =>
    prefix.endsWith("/") ? path.startsWith(prefix) : path === prefix || path.startsWith(`${prefix}/`)
  );
  return hit ? hit[1] : null;
}

/** Router location for the tutorial at `path`'s step. */
export function tutorialLocationFor(path) {
  const step = tutorialStepFor(path);
  return step ? { path: "/tutorial", query: { step } } : { path: "/tutorial" };
}
